import html2canvas from 'html2canvas';

export const handleScreenshotCapture = (name?: string, captureTitle?: string): void => {
    const elementToCapture = document.querySelector(`.card_${name}`);

    if (elementToCapture) {
        html2canvas(elementToCapture as HTMLElement).then((canvas) => {
            const screenshotDataURL = canvas.toDataURL('image/png');

            printCombinedContent(screenshotDataURL, captureTitle);
        });
    }
};

const printCombinedContent = (screenshotDataURL: string, title?: string): void => {
    const newWindow = window.open('', '_blank', 'width=800,height=600');

    if (newWindow) {
        newWindow.document.write('<p>Loading...</p>');
        newWindow.document.close();

        const img = new Image();

        img.src = screenshotDataURL;

        img.onload = () => {
            newWindow.document.body.innerHTML = '';
            newWindow.document.title = title || '';

            const container = newWindow.document.createElement('div');

            container.classList.add('print-content');

            const titleDiv = newWindow.document.createElement('div');

            titleDiv.classList.add('title');
            titleDiv.textContent = title || '';

            img.style.width = '100%';
            img.style.height = 'auto';

            container.appendChild(titleDiv);
            container.appendChild(img);
            newWindow.document.body.appendChild(container);

            setTimeout(() => {
                newWindow.focus();
                newWindow.print();
                newWindow.close();
            }, 500);
        };

        newWindow.document.body.appendChild(img);
    }
};
